export default __webpack_public_path__ + "static/media/VS.427f4bd5.svg";